export default {
	logout: 'Cerrar sesión',
}